import type { ForegroundLocationPort } from '../../../ports/ForegroundLocationPort';

export class BrowserGeolocation implements ForegroundLocationPort {
  async requestPermission(): Promise<'granted' | 'denied' | 'unsupported'> {
    if (!('geolocation' in navigator)) return 'unsupported';
    try {
      const pos = await new Promise<GeolocationPosition>((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: false,
          timeout: 5000,
        });
      });
      return 'granted';
    } catch {
      return 'denied';
    }
  }

  async getCurrentPosition(): Promise<{
    lat: number;
    lng: number;
    accuracy: number;
  }> {
    const pos = await new Promise<GeolocationPosition>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: 10000,
      });
    });
    return {
      lat: pos.coords.latitude,
      lng: pos.coords.longitude,
      accuracy: pos.coords.accuracy,
    };
  }

  watchPosition(
    callback: (pos: { lat: number; lng: number; accuracy: number }) => void,
    onUnavailable?: () => void
  ): number {
    return navigator.geolocation.watchPosition(
      (pos) => {
        callback({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
        });
      },
      () => onUnavailable?.(),
      { enableHighAccuracy: true, maximumAge: 30000 }
    );
  }

  clearWatch(watchId: number): void {
    navigator.geolocation.clearWatch(watchId);
  }
}